import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient, HttpHeaders, HttpResponse, HttpParams} from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { GLOBAL } from './global';
import { Methods } from '../shared/methods';

@Injectable({
  providedIn: 'root',
})
export class PurchaseService {
  public mtds: Methods = new Methods();
  public url: any;
  public token: any | null;
  public headers: HttpHeaders;
  public headers2: HttpHeaders;

  constructor(private _router: Router, private _http: HttpClient) {
    this.url = GLOBAL.url;
    this.token = JSON.parse(localStorage.getItem('token'));

    this.headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded',
      'X-Requested-With': 'XMLHttpRequest',
    });

    this.headers2 = new HttpHeaders({
      'Content-Type': 'text/plain',
      'X-Requested-With': 'XMLHttpRequest',
    });
  }

 

  newsync(po_id: any, type: any): Observable<any> {
    const json = { type, params: po_id };
    return this.petition(`${this.url}/backgroundprocess/new`, json);
  }

reportToJson(js: { vendor: string; filter: any; categories: any[]; types: any[]; pos: any[]; } ): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  
    return this._http.post<any>(
      `https://itaderp.com/luisha/reportToJson.php`,js,{ headers: headers }
    ).pipe(
      map((res: any) => res)
    );
    
  }

  reportToJaredApi(js: { vendor: string; filter: any; categories: any[]; types: any[]; pos: any[]; }, ep: string = '' ): Observable<any> {
    let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
  
    return this._http.post<any>(
      `https://www.itaderp.com/jaredapi/${ep}`,js,{ headers: headers }
    ).pipe(
      map((res: any) => res)
    );
    
  }



 reportMarginSummary(js: { vendor: string; rep: any; supplier: any; cv: any; po: any; pickupdate: any; donwload: boolean; id: any }): Observable<HttpResponse<Blob>>{
  let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/luisha/marginSumary/ReportMarginSummary.php`,js, {
        observe: 'response',
        headers: headers,
        responseType: "blob",
      }
    ).pipe(
      map((res: any) => res)
    );

 }

 reportPurchaseOrder(js: {  po: any; 
                            id: any; 
                            donwload: boolean; 
                            two: boolean;
                            agrupado: boolean;
                            itemsCommentsToVendor: boolean;
                            itemExtendedDescription: boolean;
                            itemDescription: boolean;
                            itemCategory: boolean;
                            hideCost: boolean;
                            oneline: boolean;
                            description: string;
                            hidessp: boolean;
                            commentsToVendor: boolean;
                            opcinalExtraCost: boolean;
                            opcionalFreight: boolean;
                            opcionalTax: boolean;
                            condicionCode: boolean;
                        }): Observable<Blob>{
  let headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });

    return this._http.post(
      `https://itaderp.com/luisha/PurchaseOrder/PurchaseOrder.php`,js, {
        headers: headers,
         responseType: 'blob' ,
      }
    ).pipe(
      map((res: any) => res)
    );
 }

 /**purchase order settings */
updatePurchaseOrderSettings(token: any, json: any, type: any): Observable<any> {
  const headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  });

  const params = new HttpParams()
    .set('authorization', token)
    .set('type', type);

  return this._http.post(
    `${this.url}/poinfo/purchase_order_settings`,
    json,
    {headers: headers,
      params: params
    }
  ).pipe(
    map((res: any) => res)
  );
}

  synciq(json: any): Observable<any> {
    //const url = `https://www.greenteksolutionsllc.com/backend/bot-extraer-pos/bot-extract-inventory-items-mass.php?po=${json}`.replace(/,/g, '-');
    const url = `https://itaderp.com/backend/bot-extraer-pos/bot-extract-inventory-items-mass.php?po=${json}`.replace(/,/g, '-');
    return this._http.get(url);
  }

  aplicarTax(ppID: any, json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/addtaxes/${ppID}`, json);
  }

    clearTax(ppID: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/removetaxes/${ppID}`);
  }

  checkAtIq(id: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/checkatiq/${id}`);
  }

  undorecivedMulty(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/undoReceivebulkpo`, json);
  }

  recivedMulty(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/reservemasspo`, json);
  }

  recivedMultyInventory(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/reservemassinventory`, json);
  }

  undorecivedMultyInventory(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/undoreceiveinventory`, json);
  }

   verifysn(id: any, task: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/verifysn/${id}`, task);
  }

  verifyca(id: any, task: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/verifyca/${id}`, task);
  }

  quickReceiveBulk(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/quickreceivebulk`, json);
  }

create(json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/getnew`, json);
  }

  update(json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/edit/${json.id}`, json);
  }

  showOne(id: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/orderdetail/${id}`);
  }

  showLine(id: any, history = false): Observable<any> {
    return this.petition(`${this.url}/${history ? 'inventory_history' : 'inventory'}/detail/${id}`);
  }

  lines(id: any, paginados = ''): Observable<any> {
    return this.petition(`${this.url}/poinfo/polineitems/${id}${paginados}`);
  }

  poonlylines(id: any, paginado: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/po_only_lines/${id}`);
  }

  noGroupLines(id: any, paginado: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/polineitems_desglosado/${id}${paginado}`);
  }

  shipStatus(so_id: any, json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/setshipstatus/${so_id}`, json);
  }

  editCostInventory(inventory_id: any, json: any, type: any): Observable<any> {
    switch (type) {
      case 'history':
        return this.petition(`${this.url}/inventory_history/especificedit/${inventory_id}`, json);
      default:
        return this.petition(`${this.url}/inventory/especificedit/${inventory_id}`, json);
    }
  }

  showAll(page: number, perPage: number, busqueda = null, type: any = 'ALL', sort = '', sortby = '', filtros = []): Observable<any> {
    let json = null;
    if (busqueda !== null && busqueda !== '') {
      json = {
        busqueda: busqueda,
      };
    }

    let url = `${this.url}/poinfo/listbystatus/${type}?page=${page}&perpage=${perPage}`;
    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = `${url}&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
    return this.petition(url, json);
  }
  showAllNew(page: any, perPage: any, busqueda = null, type: any = 'ALL', sort = '', sortby = '', filtros = [], task: any,): Observable<any> {
    /* let json= JSON.stringify(task) */
  
   /*    json = {
        busqueda: busqueda,
      };
     */

    let url = `${this.url}/poinfo/listbystatus/${type}?page=${page}&perpage=${perPage}`;
    if (sortby) {
      if (sort === '') {
        sort = 'DESC';
      }
      url = `${url}&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    for (let filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }
    return this.petition(url, task);
  }
  reciveInventory(json: any, type: any): Observable<any> {
    switch (type) {
      case 'history':
        return this.petition(`${this.url}/inventory_history/reservebulkpo`, json);
      default:
        return this.petition(`${this.url}/inventory/reservebulkpo`, json);
    }
  }

  addLineItem(json: any): Observable<any> {
    if (json.type !== 'ScrapInventory') {
      json.type = 'Inventory';
    }
    return this.petition(`${this.url}/poinfo/additems`, json);
  }


  addLineItemPhoneCheck(id: any, json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/additemsphonecheck/${id}`, json);
  }

  addLineItembulk(json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/additemsbulk`, json);
  }

  removeLineItem(id: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/removegroupitem/${id}`);
  }

  toexcel(json: any): Observable<any> {
    return this.petitionJson('https://itaderp.com/backend/reports/download-receiving-report.php', json);
  }

   fulldocument(json) {
    return this.petitionJson("https://itaderp.com/backend/reports/download-full-receiving-report.php", json);
  }

  sumary(id: any, params = ''): Observable<any> {
    return this.petition(`${this.url}/poinfo/view-summary/${id}${params}`);
  }

  doVoid(id: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/dovoid/${id}`);
  }

  quickReceive(id: any): Observable<any> {
    return this.petition(`${this.url}/inventory/quickreceive/${id}`);
  }

  changeStatus(data: any[], status: any): Observable<any> {
    const json = {
      bulk: data,
      status: status,
    };
    return this.petition(`${this.url}/poinfo/change-status-bulk`, json);
  }

  locationBulk(json: any): Observable<any> {
    return this.petition(`${this.url}/weightitem/changelocationnoweights`, json);
  }

  changeLocationMasive(json: any): Observable<any> {
    return this.petition(`${this.url}/inventory/processpogrouplinebulk`, json);
  }

  removeLine(json: any): Observable<any> {
    return this.petition(`${this.url}/poinfo/remove-item-from-po-group-bulk`, json);
  }

  editInventory(id: any, json: any): Observable<any> {
    const editUrl = json.status !== 'Removed' ? 'inventory' : 'inventory_history';
    return this.petition(`${this.url}/${editUrl}/edit/${id}`, json);
  }
  
  GetManifestbyPo(po:any): Observable<any> {
    const json = {
      po: po
    };
    return this.petition(`${this.url}/manifestitem/manifestbypo`, json);
  }



  private petition(url: any, json: any = null, type: any | null = null): Observable<any> {
    this.token = JSON.parse(localStorage.getItem('token'));
    let params = `authorization=${this.token}`;
    if (json != null) {
      params += `&json=${encodeURIComponent(JSON.stringify(json))}`;
    }
    if (type != null) {
      params += `&type=${type}`;
    }
    

    return this._http.post(url, params, { headers: this.headers })
      .pipe(
        map((res: any) => res),
        catchError((error: any) => {
          if (error.code === 404) {
            this.mtds.notifyError('Your session has expired');
            localStorage.clear();
            this._router.navigate(['/pages/lock']);
          }
          throw error;
        })
      );
  }


petitionJson(url, json = null, type = null) {
  let paramas = json;

  return this._http
    .post(url, paramas, { headers: this.headers2, observe: 'response' })
    .pipe(
      map((res: any) => res),
      catchError((error) => {
        if (error.status === 404) {
          this.mtds.notifyError("Your session has expired");
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        }
        return throwError(error);
      })
    );
}



}
